/**
 * CDR record class
 */
import formatPhoneNum from '@/filters/phone_num'

export default class {
  constructor (data) {
    this.calleeId = data.callee_id
    this.callerId = data.caller_id
    this.calldate = data.date
    this.duration = ~~data.duration
    this.fromNum = data.from
    this.toNum = data.to
    this.id = data.id
    this.direction = data.direction
    this.recording = data.recording

    this._setCIDNames()
  }

  get fromDisplay () { return this._display(this.fromName, this.fromNum) }
  get toDisplay () { return this._display(this.toName, this.toNum) }
  get callTimestamp () { return new Date(this.calldate).getTime() }
  get isFailed () { return /^E_/.test(this.toNum) }
  get isInbound () { return this.direction === 'inbound' }

  /**
   * @private
   * Set from/to caller id names
   */
  _setCIDNames () {
    const { num: fnum, name: fname } = this._setCID(this.fromNum, this.callerId)
    this.fromNum = fnum
    this.fromName = fname
    const { num: tnum, name: tname } = this._setCID(this.toNum, this.calleeId)
    this.toNum = tnum
    this.toName = tname
  }

  _setCID (num, cid) {
    const data = { num: num, name: null }
    if (num === 'MOH') {
      return { num: '*86', name: 'Music on Hold' }
    }
    if (!cid) {
      return data
    }
    const match = cid.match(/^"?([^<"]+)"? <([^>]+)>$/)
    if (!match) {
      return data
    }
    data.num = match[2]
    data.name = match[1]
    return data
  }

  _display (name, num) {
    const alias = this._aliasDest(num)
    if (alias) {
      return alias
    }
    num = formatPhoneNum(num)
    if (name) {
      return `${name} <${num}>`
    }
    return num
  }

  _aliasDest (num) {
    if (!num) return null

    const matchTable = [
      {
        test: /^(MY)?VM(BNP_\d+)?$/,
        match: null,
        name: 'Voicemail'
      }, {
        test: /^MEETME_/,
        match: /^MEETME_(\d+)\*\d+/,
        name: 'Conference'
      }, {
        test: /^PERSONALCONF/,
        match: null,
        name: 'Personal Conference'
      }, {
        test: /^PARKING_/,
        match: /^PARKING_(\d+)/,
        name: 'Parking lot'
      }, {
        test: /^PARKINGPICKUP_/,
        match: /^PARKINGPICKUP_(\d+)/,
        name: 'Parking pickup'
      }, {
        test: /^(MY)?QUEUE_/,
        match: /^(?:MY)?QUEUE_(\d+)/,
        name: 'Call Queue'
      }, {
        test: /^JITSI_/,
        match: /^JITSI_(\d+)/,
        name: 'Jitsi Conference'
      }
    ]

    for (const rule of matchTable) {
      if (rule.test.test(num)) {
        if (!rule.match) {
          return rule.name
        }
        const m = num.match(rule.match)
        if (m) {
          return `${rule.name} <${m[1]}>`
        }
      }
    }
    return null
  }
}
